export default __webpack_public_path__ + "static/Ogg-LightItalic-b685601cb5ca4797e1a92b1f4cd68d4e.ttf";